import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { archivosFiles } from '../../../services/api';
import { getAllPublicoNewsletterAction } from '../../../store/actions';
import { CLEAR_ALL_PUBLICO_NEWSLETTER } from '../../../store/types';
import { device } from '../../../utils/constants';

const ContenidoDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media ${device.mobile} {
    margin: 0;
    padding: 0.5em 0;
  }
`;

const ListaNewsletterComponent = ({ select }) => {
  const dispatch = useDispatch();

  const newsletterStore = useSelector((state) => state.newsletter);

  const isMobileDevice = useMediaQuery({ query: device.mobile });

  useEffect(() => {
    async function fetchData() {
      dispatch({
        type: CLEAR_ALL_PUBLICO_NEWSLETTER,
        payload: [],
      });
      if (select) {
        await getAllPublicoNewsletterAction(dispatch, {
          page: 1,
          tipoBoletin: select?.id,
        });
      }
    }
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [select]);

  return (
    <div
      style={{
        width: '90%',
        margin: '0 auto',
      }}
    >
      {newsletterStore.allPublico.map((el, i) => {
        return (
          <div
            style={{
              backgroundColor: el.backgroundColor ?? '#FFFFFF',
              paddingBottom: el.paddingBottom ?? '3em',
              marginTop: el.marginTop ?? '0px',
            }}
          >
            <ContenidoDiv key={el.id ?? i}>
              <a
                href={el.link === '#' || !el.link ? null : el.link}
                target="_blank"
                rel="noreferrer"
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    width: isMobileDevice
                      ? `${el.anchoMovil ?? '90'}vw`
                      : `${el.ancho ?? '80'}vw`,
                  }}
                >
                  {el.png && (
                    <img
                      src={`${archivosFiles}/${el.png.folder}/${el.png.nombre}`}
                      style={{
                        width: isMobileDevice
                          ? `${el.anchoMovilImg2 ?? '90'}vw`
                          : `${el.anchoImg2 ?? '80'}vw`,
                        position: 'absolute',
                      }}
                      alt={`gif_${i}`}
                    />
                  )}
                  <img
                    src={`${archivosFiles}/${el.gif.folder}/${el.gif.nombre}`}
                    style={{ width: '100%', height: '100%' }}
                    alt={`png_${i}`}
                  />
                </div>
              </a>
            </ContenidoDiv>
          </div>
        );
      })}
    </div>
  );
};

export default ListaNewsletterComponent;
